import { Injectable } from '@angular/core';

import { EnvironmentService, ErableHttpService } from '@ecm/consumer';

import { EnvEnum } from '../shared/enums/env.enum';

@Injectable({
    providedIn: 'root',
})
export class ClearCacheService {
    public constructor(
        private readonly http: ErableHttpService,
        private readonly environmentService: EnvironmentService,
    ) {}

    public clear(apiEntries: { apiKey: EnvEnum; params?: string }[]): boolean {
        const env: any = this.environmentService.instant();
        let clear = true;
        apiEntries.forEach((entry: { apiKey: EnvEnum; params?: string }) => {
            let missingApiKey = false;
            const nodesUrl: string[] = entry.apiKey.split('.');
            let currentEnv = env;
            nodesUrl.forEach((node: string) => {
                if (currentEnv[node]) {
                    currentEnv = currentEnv[node];
                } else {
                    missingApiKey = true;
                }
            });
            if (entry.params) {
                currentEnv = `${currentEnv}${entry.params}`;
            }
            if (!missingApiKey) {
                clear = clear && this.http.clear(currentEnv);
            }
        });
        return clear;
    }
}
